import { useStore } from 'zustand';
import { useGroupMembers, type SessionStoreInstance } from '@/store/client';
import { SessionEditorContext } from '../../session-parts';

export interface SessionGroupEditorContextProps {
  children: ReactNode;
  sessionStoreInstance: SessionStoreInstance;
}

export function SessionGroupEditorContext({
  children,
  sessionStoreInstance,
}: SessionGroupEditorContextProps) {
  const groupAccess = useStore(sessionStoreInstance, (state) => state.groupAccess);
  const { members, run, removeEventListener } = useGroupMembers(
    sessionStoreInstance.getState().session?.chat_id
  );

  const getMembers = useCallback(() => {
    return members;
  }, [members]);

  const onMentionOpenChange = useCallback(
    (open: boolean) => {
      if (open) {
        run();
      } else {
        removeEventListener();
      }
    },
    [run, removeEventListener]
  );

  return (
    <SessionEditorContext
      getMembers={getMembers}
      disabledMentionAll={!groupAccess?.canAtAll}
      onMentionOpenChange={onMentionOpenChange}
    >
      {children}
    </SessionEditorContext>
  );
}
